import React from 'react';
import Navbar from './components/navbar';
import Home from './components/home';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
    </div>
  );
}

export default App;
